import { ICreditCardVerifyPayload } from '@packlink/payment-options';
import { Amplitude3DsecureProperties, ProviderName, Tracker } from '@packlink/metrics';
import { IAmplitude3Dsecure } from '@types';

export const get3DsecureAmplitudePayload = (verification: ICreditCardVerifyPayload): IAmplitude3Dsecure => {
    return {
        [Amplitude3DsecureProperties.SECURE_CHECK]: verification.threeDSecureInfo.liabilityShiftPossible,
        [Amplitude3DsecureProperties.SECURE_VERIFICATION]: verification.threeDSecureInfo.liabilityShifted,
        [Amplitude3DsecureProperties.SECURE_VERSION]: verification.threeDSecureInfo.threeDSecureVersion,
        [Amplitude3DsecureProperties.CARD]: verification.binData.debit === 'Yes' ? 'Debit' : verification.binData.debit,
        [Amplitude3DsecureProperties.CARD_TYPE]: verification.details.cardType,
        [Amplitude3DsecureProperties.SECURE_STATUS]: verification.threeDSecureInfo.status,
        [Amplitude3DsecureProperties.SECURE_ENROLLED]: verification.threeDSecureInfo.enrolled,
    };
};

const metrics = new Tracker({ debug: false });

metrics.addProvider({
    key: config.amplitude.apikey,
    name: ProviderName.AMPLITUDE,
});

export default metrics;
